<template>
  <div class="container">
    <h1 class="title has-text-centered has-text-weight-bold">{{ tittle }}</h1>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="notification is-info" v-show="!sent">
          <p>
            Just tell us the email address you used to create your account and
            we'll send you the instructions to get a new password!
          </p>
        </div>
        <form
          v-if="!sent"
          id="forgotForm"
          @submit="submitForm($event)"
          novalidate
        >
          <div class="field">
            <label for="email" class="label">
              Email
            </label>
            <div class="control has-icons-left">
              <input
                id="email"
                required="required"
                name="email"
                class="input"
                placeholder="john.doe@example.com"
                :class="{ 'is-danger': !email.valid }"
                type="email"
                v-model="forgot"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </div>
            <p class="help" :class="{ 'is-danger': !email.valid }">
              {{ email.errorMessage }}
            </p>
          </div>
          <div class="field">
            <button
              type="submit"
              class="button is-fullwidth is-primary text-capitalize"
            >
              Send!
            </button>
          </div>
        </form>
        <template v-else>
          <div class="notification is-info">
            <h4 class="title is-4">We have received your password reset request.</h4>
            <p>
              If your email is associated to an account, we will be sending
              you an email to reset your password shortly.
            </p>
            <p>
              Please follow the instructions in the email to reset your
              password.
            </p>
            <p>
              It's also possible that the email may arrive in your spam
              folder. Please note that this password reset link expire within
              24 hours for security porpuses
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      forgot: '',
      email: {
        valid: true,
        errorMessage: ''
      },
      sent: false,
      tittle: "That's Okay. Everyone Forgets."
    };
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      let form = this.$el.querySelector('#forgotForm');
      let fields = [
        {
          field: this.$el.querySelector('#email'),
          validation: this.email
        }
      ];
      if (form.checkValidity()) {
        this.$axios
          .post(this.$API.forgotPass, { email: this.forgot })
          .then(() => {
            this.sent = true;
            this.tittle = 'Next Step! Please check your email.';
          })
          .catch(() => {
            this.sent = true;
            this.tittle = 'Next Step! Please check your email.';
          });
      } else {
        fields[0].validation.valid = fields[0].field.checkValidity();
        fields[0].validation.errorMessage = fields[0].field.validationMessage;
      }
    }
  }
};
</script>
